<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/IN92/IN92.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">IN 9.2 Cockpit&ADAS Domain Controller</div>
                <div class="detail-banner-desc">
                    IN9.2 is based on the 5th-generation platform SA8797P;<br />
                    It is integrated with multiple display interaction, 3D Vehicle model linkage, Intelligent ecological APP, Camera monitor system and etc;<br />
                    It supports functions such as instrumentation and infotainment;<br />
                    Especially for the high configuration, cross-domain between cockpit and ADAS(Advanced Driving Assisted System) is also supported, such as APA(Automated Parking Assist) / NOA(Navigate on Autopilot) and etc.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Equipped with Qualcomm 5th-generation Snapdragon Ride Elite platform.
                        </div>
                        <div>
                            Multiple operating systems (Liunx/Android) on single chip.
                        </div>
                        <div>
                            Integrated intelligent cockpit, intelligent driving，and Camera-Monitor System.
                        </div>
                        <div>
                            Up to 12 displays, 14 cameras, 6 analog mic, 104 digital mic array.
                        </div>
                        <div>
                            4*100M/2*1000M Ethernet, 9*CAN(FD), 1*LIN.
                        </div>
                        <div>
                            USB 3.1 x 2, WiFi 7, BT 5.4.
                        </div>
                        <div>
                            HiCar/ICCOA/Carplay/Android Auto.
                        </div>
                        <div>
                            Support end side large model.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN92/IN92-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">3nm</div>
                                    <div class="k">Process</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">64GB+512GB</div>
                                    <div class="k">Storage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">Up to 12</div>
                                    <div class="k">Display</div>
                                </div>

                                <div class="spec-item spec-item-last">
                                    <div class="v">CPU:660K DMIPS、GPU:8.1 TFLOPS</div>
                                    <div class="k">Computing power</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">1000 Base-T1 + 4*100 Base-T1</div>
                                    <div class="k">Ethernet</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Main BT: BT5.4、Vice BT: BT5.3 & BLE、WIFI6 & WIFI7</div>
                                    <div class="k">BT-WIFI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="spec-row">
                    
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                            </div>
                        </div>
                    </div>
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/IN92/IN92-1.jpg" alt="200-1-02">
                    </div>
                </div> -->
            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: 'IN 9.2 Cockpit&ADAS Domain Controller - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/electronics/IN92.html'

};

import { createApp } from 'vue';
import App from './IN92.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./IN92.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
